import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { THING_ACTION_OVERRIDES } from "../common/endpoints";
import { ThingActionOverride } from "../model";
import { HttpService } from "./http.service";

@Injectable()
export class ThingActionOverrideService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService,
    ) { }

    getByThingId(thingId: string): Promise<ThingActionOverride[]> {
        const params = new HttpParams().set('thingId', thingId);
        return firstValueFrom(this.http.get<ThingActionOverride[]>(THING_ACTION_OVERRIDES, params));
    }

}